import { makeContextModule } from '@cian/react-utils';

export interface ILocalContext {
  /** Рефка на форму оценки, расположенную на самой странице (не в модалке) */
  formRef?: React.RefObject<HTMLDivElement>;
}

export const {
  Context: LocalContext,
  useContext: useLocalContext,
  withContext: withLocalContext,
} = makeContextModule<ILocalContext>({
  contextName: 'LocalContext',
  defaultValue: {
    formRef: undefined,
  },
});
